/*
 * @LastEditors: caobopan
 * @LastEditTime: 2022-12-14 15:24:29
 * @Description: feature页面
 * @FilePath: /starmaker-starvr-officialnew/src/pages/home/components/shareic/index.js
 */

import './index.scss';
import { shareList } from './static'
const Shareic = () => {
  const goLink = (link) => {
    // window.location.href = link
    window.open(link, "_blank")
  }
  return (
    <div className="Shareic">
      <div className='px-44 inner flex items-center justify-center'>
        {shareList && shareList.map((item) =>
          <div className='cursor-pointer px-4' key={item.link} onClick={() => goLink(item.link)}>
            <img className='h-20 w-20' src={item.img} alt='' />
          </div>
        )}
      </div>
    </div>
  );
}

export default Shareic;
